import { useEffect, useState } from "react";
import { api } from "../../../mock/api";
import { useTranslation } from "react-i18next";

export const useHomeContent = () => {
  const { i18n } = useTranslation();
  const [data, setData] = useState<any>(null);

  useEffect(() => {
    api.getHome(i18n.language).then(setData);
  }, [i18n.language]);

  return data;
};
